import type Controller from '@ember/controller';
import type Transition from '@ember/routing/transition';
import { type Registry as Services, service } from '@ember/service';
import { AlertStatus } from 'uplisting-frontend/models/alert';
import BaseRoute from 'uplisting-frontend/pods/base/route';
import type NotificationsUplistingController from 'uplisting-frontend/pods/notifications/uplisting/controller';

export default abstract class NotificationsUplistingBaseRoute extends BaseRoute {
  @service('repositories/alert')
  alertsRepository!: Services['repositories/alert'];

  @service('repositories/property')
  propertyRepository!: Services['repositories/property'];

  abstract alertStatus: AlertStatus;

  async setupController(controller, model, transition): Promise<void> {
    const parentController = this.controllerFor(
      'notifications.uplisting',
    ) as NotificationsUplistingController;

    super.setupController(controller, model, transition);

    parentController.status = this.alertStatus;
    parentController.allAlertsLoaded = false;
    parentController.properties = (
      await this.propertyRepository.findAll()
    ).slice();

    await parentController.fetchData(this.alertStatus, true);
  }

  resetController(
    controller: Controller,
    isExiting: boolean,
    transition: Transition,
  ): void {
    super.resetController(controller, isExiting, transition);

    const parentController = this.controllerFor(
      'notifications.uplisting',
    ) as NotificationsUplistingController;

    parentController.alerts = [];

    this.alertsRepository.unloadAll();
  }
}
